declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanRequest, CounsellingPlanController, SaveIvfTreatmentCyclesInfoRequest, SaveTestMedCycleActivitiesRequest, SaveEggDonorEpisode, GenericProcPostRequest, S_Methods } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { NgbSearchDonarModal } from '../TreatmentCycle/searchdonar.modal';
import { NgbSearchDonarreModal } from '../TreatmentCycle/searchdonarre.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSearchDonarEpisodeModal } from '../TreatmentCycle/searchdonarepisode.modal';
@Component({
  selector: 'newcycle',
  templateUrl: './newcycle.modal.html',
  styleUrls: ['./newcycle.modal.scss']
})

export class NgbNewCycleModal implements OnInit {


  @Input() ActorDocCode;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  LmpEgg: NgbDateStruct;
  LmpRecepient: NgbDateStruct;
  ProtocolStartDate: NgbDateStruct;
  ProtocolEndDate: NgbDateStruct;
  StartDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  public FacilityName: string;
  // public EggDonarName: string;
  public BranchName: string;
  public SelectedPatientFormatted: string;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ShowList: boolean = true;
  public Selfbadge: boolean = false;
  public DonorEggBadge: boolean = false;
  public Surrogatebadge: boolean = false;
  public DonorEggSurrogatebadge: boolean = false;
  public ShowFetdata: boolean = false;
  public index1: boolean = false;
  public index2: boolean = false;
  public index3: boolean = false;
  public isEdit: boolean = false;
  public ShowEggDonorData: boolean = false;
  public ShowsurrogateData: boolean = false;
  public index1self: boolean = false;
  public index2self: boolean = false;
  public index3self: boolean = false;
  public index1fet: boolean = false;
  public Fetbadge: boolean = false;
  public index2fet: boolean = false;
  public index3fet: boolean = false;
  public ShowDemData: boolean = false;
  public index1dem: boolean = false;
  public index2dem: boolean = false;
  public index3dem: boolean = false;
  public Dembadge: boolean = false;
  public index1EggDonorData: boolean = false;
  public index2EggDonorData: boolean = false;
  public index3EggDonorData: boolean = false;
  public index1surrogateData: boolean = false;
  public index2surrogateData: boolean = false;
  public index3surrogateData: boolean = false;
  public index1eggdonorsurrogate: boolean = false;
  public index2eggdonorsurrogate: boolean = false;
  public index3eggdonorsurrogate: boolean = false;
  public displayTreatment: boolean = false;
  public displayProtocol: boolean = false;
  public Ivfsave: boolean = true;
  public SelectionPart: boolean = true;
  public Protocol: string;
  public Treamentplan: string;
  public displayicon: boolean = false;
  public plansave: boolean = false;
  public eggdonorsurrogate: boolean = false;
  public Showselfdata: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  private isvisible = true;
  DocFriendlyName: string = "";

  public IsChecked: boolean;
  CurrentSaveIvfTreatmentCyclesInfoRequest: SaveIvfTreatmentCyclesInfoRequest;
  CurrentSaveTestMedCycleActivitiesRequest: SaveTestMedCycleActivitiesRequest;
  CurrentSaveCounsellingPlanRequest: SaveCounsellingPlanRequest;
  CurrentEditCounsellingPalnRequest: SaveCounsellingPlanRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientDetails: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentActorDocController: ActorDocController[];

  @ViewChild('f') IdentitiesForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number = 0;

  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;

          this.CurrentPatientDetails = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

          this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentCounsellingPlanController: CounsellingPlanController[];
  CurrentCounsellingPlanRequest: CounsellingPlanRequest;
  LoadPatientCounsellingPlansIfAny() {
    this.LoadCounselling();
  }

  LoadCounselling() {

    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
    this.CurrentCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    this.CurrentCounsellingPlanRequest.ConditionalOperator = 25; // patient -all active plans
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingPlanController();
  }
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetCounsellingPlanController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingPlanController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  ActorCode: number;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService, private modalService: NgbModal,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.BranchName = AppData.Instance().SelectedBranchName;
    //alert(AppData.Instance().SelectedBranchName);
    this.LoadPatients();
    this.CurrentSaveCounsellingPlanRequest = new SaveCounsellingPlanRequest();

    this.CurrentSaveCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest = new SaveIvfTreatmentCyclesInfoRequest();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentEditCounsellingPalnRequest = new SaveCounsellingPlanRequest();
    //this.CurrentEditCounsellingPalnRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditCounsellingPalnRequest = new SaveCounsellingPlanRequest();
    this.CurrentEditCounsellingPalnRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }






  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  edit(EditCounsellingplanController: CounsellingPlanController) {
    this.ShowList = false;
    this.isEdit = true;
    this.CurrentEditCounsellingPalnRequest.PlanStatus = EditCounsellingplanController.PlanStatus;

    this.CurrentEditCounsellingPalnRequest.TreatmentPlan = EditCounsellingplanController.TreatmentPlan;
    this.CurrentEditCounsellingPalnRequest.BranchCode = EditCounsellingplanController.BranchCode;
    this.CurrentEditCounsellingPalnRequest.StartDate = EditCounsellingplanController.StartDate;
    this.CurrentEditCounsellingPalnRequest.Concerns = EditCounsellingplanController.Concerns;
    this.CurrentEditCounsellingPalnRequest.CounsellingDoctor = EditCounsellingplanController.CounsellingDoctor;
    this.CurrentEditCounsellingPalnRequest.EndDate = EditCounsellingplanController.EndDate;
    this.CurrentEditCounsellingPalnRequest.FinancialStatus = EditCounsellingplanController.FinancialStatus;
    this.CurrentEditCounsellingPalnRequest.PackageCost = EditCounsellingplanController.PackageCost;
    this.CurrentEditCounsellingPalnRequest.CounsellingPlanCode = EditCounsellingplanController.CounsellingPlanCode;
    this.CurrentEditCounsellingPalnRequest.PlanStatus = EditCounsellingplanController.PlanStatus;
    this.CurrentEditCounsellingPalnRequest.Potential = EditCounsellingplanController.Potential;
    this.CurrentEditCounsellingPalnRequest.RecommendedPackage = EditCounsellingplanController.RecommendedPackage;
    this.CurrentEditCounsellingPalnRequest.Remarks = EditCounsellingplanController.Remarks;
    this.CurrentEditCounsellingPalnRequest.SelectEmi = EditCounsellingplanController.SelectEmi;
    this.CurrentEditCounsellingPalnRequest.ActorCode = EditCounsellingplanController.ActorCode.toString();
    //this.CurrentEditCounsellingPalnRequest.VisitCode = EditCounsellingplanController.VisitCode;
    this.FacilityName = EditCounsellingplanController.FacilityShortName;
    if (this.CurrentEditCounsellingPalnRequest.StartDate != null) {
      var SValidFrom = new Date(this.CurrentEditCounsellingPalnRequest.StartDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.StartDate >1990');
        this.StartDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentEditCounsellingPalnRequest.EndDate != null) {
      var SValidTo = new Date(this.CurrentEditCounsellingPalnRequest.EndDate);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.EndDate >1990');
        this.EndDate = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }
  }
  back() {
    this.ShowList = true;
    this.isEdit = false;
  }
  onAssignedToActorCode(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveCounsellingPlanRequest.BranchCode = event;
      // console.log('event--_>' + event);
      //   }
    }

  }
  FacilityCode: number;
  //isvisiblebutton() {

  //  this.isvisible = false;
  //}
  onSubmit() {
    this.isvisible = false;

    this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 40;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveCounsellingPlan(this.CurrentSaveCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  dispalyIvf() {
    this.Ivfsave = false;
    this.plansave = true;
  }
  DisplayStep2() {

    this.index1 = false;
    this.index2 = true;
    this.index1self = false;
    this.index2self = true;
    this.displayTreatment = true;
    this.displayProtocol = true;
    this.Protocol = this.CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName;
    this.Treamentplan = this.CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType;
  }
  Displaystep2fet() {
    this.index1fet = false;
    this.index2fet = true;
    this.displayTreatment = true;
    this.displayProtocol = true;
    this.Protocol = this.CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName;
    this.Treamentplan = this.CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType;

  }
  Displaystep1() {
    this.index1 = true;
    this.index2 = false;
    this.index1self = true;
    this.Selfbadge = true;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2self = false;
    this.displayProtocol = false;
    this.displayTreatment = false;
  }
  Displayfetstep1() {
    this.index1fet = true;
    this.index2fet = false;
    this.Fetbadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.displayProtocol = false;
    this.displayTreatment = false;

  }
  Displaystep3() {
    this.index1 = false;
    this.index2 = false;
    this.index3 = true;
    this.index1self = false;

    this.index2self = false;
    this.index3self = true;
    this.Selfbadge = true;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  Displayfetstep3() {
    this.index1fet = false;
    this.index2fet = false;
    this.index3fet = true;
    this.Fetbadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }


  Display3() {
    this.index1 = false;
    this.index2 = true;
    this.index3 = false;
    this.index1self = false;
    this.index2self = true;
    this.Selfbadge = true;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index3self = false;
  }
  Displayfet3() {
    this.index1fet = false;
    this.index2fet = true;
    this.Fetbadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index3fet = false;
  }
  Back() {
    this.SelectionPart = true;
    this.index1self = false;
    this.index2self = false;
    this.index3self = false;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
  }
  FetBack() {
    this.SelectionPart = true;
    this.index1fet = false;
    this.index2fet = false;
    this.index3fet = false;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;

  }
  ShowSelf() {
    this.Showselfdata = true;
    this.SelectionPart = false;
    this.ShowsurrogateData = false;
    this.ShowEggDonorData = false;
    this.eggdonorsurrogate = false;
    this.index1self = true;
    this.Selfbadge = true;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2self = true;
    this.index3self = true;
  }
  ShowFet() {
    this.ShowFetdata = true;
    this.SelectionPart = false;
    this.ShowDemData = false;

    this.ShowsurrogateData = false;
    this.ShowEggDonorData = false;
    this.eggdonorsurrogate = false;
    this.index1fet = true;
    this.Fetbadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2fet = true;
    this.index3fet = true;

  }
  ShowDem() {
    this.ShowDemData = true;
    this.SelectionPart = false;
    this.ShowFetdata = false;
    this.ShowsurrogateData = false;
    this.ShowEggDonorData = false;
    this.eggdonorsurrogate = false;
    this.index1dem = true;
    this.Dembadge = true;
    this.Selfbadge = false;
    this.Fetbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2dem = true;
    this.index3dem = true;
  }
  ShowEggDonor() {
    this.SelectionPart = false;
    this.ShowEggDonorData = true;
    this.Showselfdata = true;
    this.ShowsurrogateData = false;
    this.eggdonorsurrogate = false;
    this.index1EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index3EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
  }
  DisplayEggDonor1() {
    this.index2EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index1EggDonorData = false;
    this.index3EggDonorData = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
    this.Protocol = this.CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName;
    this.Treamentplan = this.CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType;
  }
  DisplayDem1() {
    this.index2dem = true;
    this.Dembadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index1dem = false;
    this.index3dem = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
    this.Protocol = this.CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName;
    this.Treamentplan = this.CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType;
  }
  DisplayEggDonor2() {
    this.index1EggDonorData = false;
    this.index2EggDonorData = false;
    this.index3EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  DisplayDem2() {
    this.index1dem = false;
    this.index2dem = false;
    this.index3dem = true;
    this.Dembadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }

  DisplayEggDonorstep1() {
    this.index1EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2EggDonorData = false;
    this.index3EggDonorData = false;
    this.displayTreatment = false;
    this.displayProtocol = false;
  }
  DisplayDemstep1() {
    this.index1dem = true;
    this.Dembadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index2dem = false;
    this.index3dem = false;
    this.displayTreatment = false;
    this.displayProtocol = false;
  }

  DisplayEggDonorstep3() {
    this.index1EggDonorData = false;
    this.index2EggDonorData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = true;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index3EggDonorData = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  DisplayDemstep3() {
    this.index1dem = false;
    this.index2dem = true;
    this.Dembadge = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
    this.index3dem = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  Back2() {
    this.SelectionPart = true;
    this.index1EggDonorData = false;
    this.index2EggDonorData = false;
    this.index3EggDonorData = false;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
  }
  Back2Dem() {
    this.SelectionPart = true;
    this.index1dem = false;
    this.index2dem = false;
    this.index3dem = false;
    this.Dembadge = false;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
  }

  ShowEggandsurogate() {
    this.SelectionPart = false;
    this.eggdonorsurrogate = true;
    this.ShowEggDonorData = false;
    this.Showselfdata = false;
    this.ShowsurrogateData = false;
    this.index1eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
    this.index2eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
    this.index3eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
  }

  Back5() {
    this.SelectionPart = true;
    this.index1eggdonorsurrogate = false;
    this.index2eggdonorsurrogate = false;
    this.index3eggdonorsurrogate = false;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
  }
  Displayeggsurgatestep2() {
    this.index2eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
    this.index1eggdonorsurrogate = false;
    this.index3eggdonorsurrogate = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
    this.Protocol = this.CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName;
    this.Treamentplan = this.CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType;
  }
  Displayeggsurrogatestep3() {
    this.index3eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
    this.index1eggdonorsurrogate = false;
    this.index2eggdonorsurrogate = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  Displayeggsurrogatestep2back() {
    this.index2eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
    this.index3eggdonorsurrogate = false;
    this.index1eggdonorsurrogate = false;
  }
  Displaystep2back() {
    this.index1eggdonorsurrogate = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = true;
    this.index2eggdonorsurrogate = false;
    this.index3eggdonorsurrogate = false;
    this.displayProtocol = false;
    this.displayTreatment = false;
  }
  Showsurrogate() {
    this.SelectionPart = false;
    this.ShowsurrogateData = true;
    this.eggdonorsurrogate = false;
    this.ShowEggDonorData = false;
    this.Showselfdata = false;
    this.index1surrogateData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = true;
    this.DonorEggSurrogatebadge = false;
    this.index2surrogateData = true;
    this.index3surrogateData = true;
  }
  Displaysurroagte3() {
    this.index3surrogateData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = true;
    this.DonorEggSurrogatebadge = false;
    this.index2surrogateData = false;
    this.index1surrogateData = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  Displaysurroagteback() {
    this.index2surrogateData = false;
    this.index1surrogateData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = true;
    this.DonorEggSurrogatebadge = false;
    this.index3surrogateData = false;
    this.displayTreatment = false;
    this.displayProtocol = false;
  }
  Back3() {
    this.SelectionPart = true;
    this.index1surrogateData = false;
    this.index2surrogateData = false;
    this.index3surrogateData = false;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = false;
    this.DonorEggSurrogatebadge = false;
  }
  Displaysurrogate2() {
    this.index2surrogateData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = true;
    this.DonorEggSurrogatebadge = false;
    this.index1surrogateData = false;
    this.index3surrogateData = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
    this.Protocol = this.CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName;
    this.Treamentplan = this.CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType;

  }
  Displaysurogatestep2() {
    this.index2surrogateData = true;
    this.Selfbadge = false;
    this.DonorEggBadge = false;
    this.Surrogatebadge = true;
    this.DonorEggSurrogatebadge = false;
    this.index3surrogateData = false;
    this.index1surrogateData = false;
    this.displayTreatment = true;
    this.displayProtocol = true;
  }
  //ShowEggandsurogate() {
  //  this.index1eggdonorsurrogate
  //}
  patientName: string;
  PatientFomratted: string;
  patientActorCode: number;
  patientNamere: string;
  PatientreFomratted: string;
  patientreActorCode: number;
  SelectDonorForEgg() {
    const modalRef = this.modalService.open(NgbSearchDonarModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patientName = receivedEntry.make;
      this.PatientFomratted = receivedEntry.value;
      this.patientActorCode = receivedEntry.key2;
      //alert(this.Code);
    })
  }
  SelectDonor() {
    const modalRef = this.modalService.open(NgbSearchDonarModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })    
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.DonorName = receivedEntry.make;
      this.DonorFomratted = receivedEntry.value;
      this.DonorActorCode = receivedEntry.key2;
      //alert(this.Code);
    })
  }
  public DonorName: string;
  public DonorFomratted: string;
  public DonorActorCode: number;
  public DonorCycleCode: number;
  public DonorEpisode: number;
  SelectDonorEpisode() {
    const modalRef = this.modalService.open(NgbSearchDonarEpisodeModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.DonorActorCode = this.DonorActorCode;
    //modalRef.componentInstance.DonorCycleCode = this.DonorCycleCode;
    modalRef.result.then((val: any) => {
      this.DonorName = val.EggName;
      this.DonorEpisode = val.Episode;
      //this.DonorCycleCode = val.Code;
      //this.DonorActorCode = val.ActorCode;
      //this.DonorRegistrationCode = val.PatientCode;
    });
    //modalRef.componentInstance.passEntry.subscribe((receivedEntry2) => {
    //  this.DonorName = receivedEntry2.make2;
    //  this.DonorEpisode = receivedEntry2.value2;
    //  this.DonorCycleCode = receivedEntry2.key3;
    //})
  }
  SelectDonorForReceipt() {
    const modalRef = this.modalService.open(NgbSearchDonarreModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patientNamere = receivedEntry.make;
      this.PatientreFomratted = receivedEntry.value;
      this.patientreActorCode = receivedEntry.key2;
      //alert(this.Code);
    })
  }
  onSubmit2() {
    //alert("save");
    this.spinner.show();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientName = this.CurrentPatientDetails.DisplayName
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientLMP = new Date(this.parserFormatter.format(this.LmpRecepient));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserCode = AppData.Instance().UserLoginDetails.EmpFormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.IvfTreatmentCycleCode = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceActorCode = this.patientActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceFormattedCode = this.PatientFomratted;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientActorCode = this.patientreActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientFormattedCode = this.PatientreFomratted;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelID = 4;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelName = "DonorEggSurrogate";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType = "Donor";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType = "Donor";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle = '';
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Droplet Culture";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonor = 0;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonorName = "";
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Well Culture";
    //this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    //this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    //this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    //this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    //this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveIvfTreatmentCyclesInfo(this.CurrentSaveIvfTreatmentCyclesInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  onSubmitself() {
    //alert("save");
    this.spinner.show();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientName = this.CurrentPatientDetails.DisplayName
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType = "Self";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType = "Self"
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientLMP = new Date();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserCode = AppData.Instance().UserLoginDetails.EmpFormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.IvfTreatmentCycleCode = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelID = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelName = "Self";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle = '';
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Droplet Culture";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonor = 0;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonorName = "";
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Well Culture";
    //this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    //this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    //this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    //this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    //this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveIvfTreatmentCyclesInfo(this.CurrentSaveIvfTreatmentCyclesInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  onSubmitfet() {
    //alert("save");
    this.spinner.show();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientName = this.CurrentPatientDetails.DisplayName
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType = "Self";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType = "Self"
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientLMP = new Date();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserCode = AppData.Instance().UserLoginDetails.EmpFormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.IvfTreatmentCycleCode = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelID = 6;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelName = "Fet";
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Droplet Culture";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonor = 0;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonorName = "";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle = '';
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Well Culture";
    //this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    //this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    //this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    //this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    //this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveIvfTreatmentCyclesInfo(this.CurrentSaveIvfTreatmentCyclesInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");

            this.spinner.hide();
            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  public Remarks: string;
  public DonorCycleType: string;
  public DonorCycleNo: string; 
  public DonorGradingModel: string;
  public DonorTreatmentProtocolName: string; 
  public DonorInfertilityType: string;
  public DonorConcerns: string;
  SaveEpisode() {
    var saveReq = new SaveEggDonorEpisode();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40470;

    saveReq.DonorCycleType = this.DonorCycleType; 
    saveReq.DonorCycleNo = this.DonorCycleNo;
    saveReq.DonorGradingModel = this.DonorGradingModel;
    saveReq.DonorTreatmentProtocolName = this.DonorTreatmentProtocolName;
    saveReq.DonorInfertilityType = this.DonorInfertilityType;
    saveReq.DonorConcerns = this.DonorConcerns;

    saveReq.EggSourceType = "Donor";
    saveReq.RecepientType = "Self";
    saveReq.RecepientLMP = new Date();
    saveReq.IvfTreatmentCycleCode = 1;
    saveReq.TCModelID = 2;
    saveReq.TCModelName = "DonorEgg";

    saveReq.DonorName = this.DonorName;
    saveReq.DonorFormattedCode = this.DonorFomratted;
    saveReq.DonorCycleCode = this.DonorCycleCode;
    saveReq.DonorEpisode = this.DonorEpisode;
    saveReq.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    saveReq.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    saveReq.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    saveReq.Remarks = this.Remarks;
    saveReq.ActorCode = this.CurrentPatientDetails.ActorCode;
    saveReq.FormattedCode = this.CurrentPatientDetails.FormattedCode;
    saveReq.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    saveReq.PatientName = this.CurrentPatientDetails.DisplayName;
    saveReq.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    saveReq.CreatedUserCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40470;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  onSubmitEggDonor() {
    //alert("save");
    this.spinner.show();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientName = this.CurrentPatientDetails.DisplayName
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType = "Donor";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType = "Self"
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientLMP = new Date();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserCode = AppData.Instance().UserLoginDetails.EmpFormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.IvfTreatmentCycleCode = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceActorCode = this.patientActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceFormattedCode = this.PatientFomratted;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelID = 2;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelName = "DonorEgg";
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Droplet Culture";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonor = 0;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonorName = "";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle = '';
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Well Culture";
    //this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    //this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    //this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    //this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    //this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveIvfTreatmentCyclesInfo(this.CurrentSaveIvfTreatmentCyclesInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  onSubmitDem() {
    //alert("save");
    this.spinner.show();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientName = this.CurrentPatientDetails.DisplayName
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggLMPDate = new Date(this.parserFormatter.format(this.LmpEgg));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType = "Donor";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType = "Self"
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientLMP = new Date();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserCode = AppData.Instance().UserLoginDetails.EmpFormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.IvfTreatmentCycleCode = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceActorCode = this.patientActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceFormattedCode = this.PatientFomratted;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelID = 5;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelName = "Dem";
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Droplet Culture";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonor = this.patientActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonorName = this.patientName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle = '';
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Well Culture";
    //this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    //this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    //this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    //this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    //this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveIvfTreatmentCyclesInfo(this.CurrentSaveIvfTreatmentCyclesInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }
  onSubmitReceiptDonor() {
    //alert("save");
    this.spinner.show();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientName = this.CurrentPatientDetails.DisplayName
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.PatientRegistrationCode = this.CurrentPatientDetails.PatientRegistrationNumber;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolStartDate = new Date(this.parserFormatter.format(this.ProtocolStartDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.ProtocolEndDate = new Date(this.parserFormatter.format(this.ProtocolEndDate));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggLMPDate = new Date();
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType = "Self";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType = "Donor"
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientLMP = new Date(this.parserFormatter.format(this.LmpRecepient));
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserCode = AppData.Instance().UserLoginDetails.EmpFormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.CreatedUserName = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.IvfTreatmentCycleCode = 1;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceActorCode = this.CurrentPatientDetails.ActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceFormattedCode = this.CurrentPatientDetails.FormattedCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientActorCode = this.patientreActorCode;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientFormattedCode = this.PatientreFomratted;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelID = 3;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.TCModelName = "Surrogate";
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Droplet Culture";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonor = 0;
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.EmbryoDonorName = "";
    this.CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle = '';
    //this.CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel = "Well Culture";
    //this.CurrentSaveCounsellingPlanRequest.ActorCode = this.CurrentPatientInfoByFormattedCodeController[0].ActorCode.toString();
    //this.CurrentSaveCounsellingPlanRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    //this.CurrentSaveCounsellingPlanRequest.ConditionalOperator = 10;
    //this.CurrentSaveCounsellingPlanRequest.CreatedTimeStamp = new Date();
    //this.CurrentSaveCounsellingPlanRequest.CounsellingPlanCode = 0;
    //this.CurrentSaveCounsellingPlanRequest.Remarks = "";
    //this.CurrentSaveCounsellingPlanRequest.VisitCode = "";
    //this.CurrentSaveCounsellingPlanRequest.EndDate = new Date;
    //this.CurrentSaveCounsellingPlanRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;

    this.actorservice.SaveIvfTreatmentCyclesInfo(this.CurrentSaveIvfTreatmentCyclesInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.isvisible = false;
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );

  }




  onEditSubmit() {

    this.isvisible = false;
    this.CurrentEditCounsellingPalnRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
    this.CurrentEditCounsellingPalnRequest.EndDate = new Date(this.parserFormatter.format(this.EndDate));

    this.CurrentEditCounsellingPalnRequest.ConditionalOperator = 20;
    this.CurrentEditCounsellingPalnRequest.Remarks = "";
    this.CurrentEditCounsellingPalnRequest.CreatedUser = AppData.Instance().UserLoginDetails.DisplayName;


    this.CurrentEditCounsellingPalnRequest.VisitCode = "";


    this.actorservice.SaveCounsellingPlan(this.CurrentEditCounsellingPalnRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }
  //  if(IsChecked = "true") {
  //    this.displayicon = true;
  //  }
  //  else{
  //  this.displayicon = false;
  //}
  //PlansActive_Var: boolean = false;
  //NoPlansActive() {
  //  this.PlansActive_Var = false;
  //  if (this.CurrentCounsellingPlanController.length > 0) {

  //    var index = this.CurrentCounsellingPlanController.length;
  //    while (index > 0) {
  //      index--;
  //      if (this.CurrentCounsellingPlanController[index].PlanStatus == 'Completed' ||
  //        this.CurrentCounsellingPlanController[index].PlanStatus == 'Cancelled') {
  //        this.PlansActive_Var = false;
  //        break;

  //      }
  //    }
  //  }
  //  else {
  //    this.PlansActive_Var = true;
  //  }


  //}
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}



  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

